document.addEventListener("DOMContentLoaded", () => {
  // --- Create LightBox
  const galleryGrid = document.querySelector(".gallery-grid");
  const links = galleryGrid?.querySelectorAll("a");
  const imgs = galleryGrid?.querySelectorAll("img");
  const lightboxModal = document.getElementById("lightbox-modal");
  const bsModal = new bootstrap.Modal(lightboxModal);
  const modalBody = lightboxModal.querySelector(".lightbox-content");

  // Select all gallery items to add the water mark
  const galleryItems = document.querySelectorAll(".gallery-item");

  galleryItems.forEach((item) => {
    const watermark = document.createElement("img");
    watermark.classList.add("watermark-badge");
    watermark.src =
      "https://lmc-cpo.luckymotorcorp.com/app/uploads/2025/03/lmc-watermark-1.svg";
    watermark.alt = "Watermark";
    item.appendChild(watermark);
  });

  function createCaption(caption) {
    return `<div class="carousel-caption d-none d-md-block">
            <h4 class="m-0">${caption}</h4>
          </div>`;
  }

  function createIndicators(index) {
    let markup = "";
    if (links) {
      for (let i = 0; i < links.length; i++) {
        markup += `
              <button type="button" data-bs-target="#lightboxCarousel"
                data-bs-slide-to="${i}"
                ${i === index ? 'class="active" aria-current="true"' : ""}
                aria-label="Slide ${i + 1}">
              </button>`;
      }
      return markup;
    }
  }

  function createSlides(activeIndex) {
    let markup = "";

    if (links) {
      links.forEach((link, index) => {
        const imgSrc = link.getAttribute("href");
        // const imgAlt = link.querySelector("img").getAttribute("alt") || "Image";
        const imgAlt = "";
        markup += `
              <div class="carousel-item${index === activeIndex ? " active" : ""} position-relative">
                <img class="d-block img-fluid w-100" src="${imgSrc}" alt="${imgAlt}">
                ${imgAlt ? createCaption(imgAlt) : ""}
                <img src="https://lmc-cpo.luckymotorcorp.com/app/uploads/2025/03/lmc-watermark-1.svg" class="watermark-badge"/>
              </div>`;
      });
      return markup;
    }
  }

  function createCarousel(activeIndex) {
    const markup = `
          <!-- Lightbox Carousel -->
          <div id="lightboxCarousel" class="carousel slide carousel-fade" data-bs-ride="true">
            <!-- Indicators/dots -->
            <div class="carousel-indicators">
              ${createIndicators(activeIndex)}
            </div>
            <!-- Wrapper for Slides -->
            <div class="carousel-inner justify-content-center mx-auto">
              ${createSlides(activeIndex)}
            </div>
            <!-- Controls/icons -->
            <button class="carousel-control-prev" type="button" data-bs-target="#lightboxCarousel" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#lightboxCarousel" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
          `;
    modalBody.innerHTML = markup;
  }

  if (links) {
    links.forEach((link, index) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const lightboxCarousel = document.getElementById("lightboxCarousel");

        if (lightboxCarousel) {
          const bsCarousel = new bootstrap.Carousel(lightboxCarousel);
          bsCarousel.to(index);
        } else {
          createCarousel(index);
        }

        bsModal.show();
      });
    });
  }

  // --- Support Fullscreen
  const fsEnlarge = document.querySelector(".btn-fullscreen-enlarge");
  const fsExit = document.querySelector(".btn-fullscreen-exit");

  function enterFS() {
    lightboxModal
      .requestFullscreen()
      .then({})
      .catch((err) => {
        alert(
          `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
        );
      });
    fsEnlarge.classList.toggle("d-none");
    fsExit.classList.toggle("d-none");
  }

  function exitFS() {
    document.exitFullscreen();
    fsExit.classList.toggle("d-none");
    fsEnlarge.classList.toggle("d-none");
  }

  fsEnlarge.addEventListener("click", (e) => {
    e.preventDefault();
    enterFS();
  });

  fsExit.addEventListener("click", (e) => {
    e.preventDefault();
    exitFS();
  });
});